import template from './login-with-social.jade';
import validation from '../../../scripts/services/validation';

const CianMediaAuthentication = window.CianMediaAuthentication;

export default () => {
  return {
    require: ['cianAfLoginWithSocial', 'form'],
    template,
    scope: {},
    bindToController: {
      mergeData: '=',
      enterEmailData: '=',
    },
    link: (scope, element, attrs, ctrls) => {
      ctrls[0].init(ctrls[1]);
    },
    controller(
      $scope,
      $q,
      $log,
      userService,
      apiService,
      remoteValidationService,
      analyticsService,
      geoService,
      addFormService,
      homeownerService,
      deviceService,
      commercialOwnerService,
    ) {
      'ngInject';

      this.isMobile = deviceService.isMobile;

      this.email = '';
      this.password = '';
      this.init = form => {
        this.forgotPassword = () => {
          this.remindPassword = true;
          analyticsService.forgotPassword();
        };

        this.emailValidation = validation(form, 'email', {
          required: 'Не заполнен "E-mail"',
        });

        this.passwordValidation = validation(form, 'password', {
          required: 'Пароль не заполнен',
        });

        form.remoteValidator = remoteValidationService.getInstance(form);
        form.remoteValidator.map = data => {
          const result = {
            fields: {},
            form: {},
            sections: {},
          };

          if (data.key === 'password') {
            result.fields.password = {
              triggers: 'password',
              messages: { code: 'invalidPassword' },
            };
          }
          if (data.key === 'login') {
            result.fields.email = {
              triggers: 'email',
              messages: data,
            };
          }

          return result;
        };

        this.clearErrors = () => {
          form.remoteValidator.removeFieldError('email');
          form.remoteValidator.removeFieldError('password');
          this.isPasswordObsolete = false;
        };

        this.submiting = false;
        this.socialSubmiting = false;
        this.isPasswordObsolete = false;
        this.passwordObsoleteError = '';
        this.submit = () => {
          // TODO подумать как быть с автоподстановкой полей
          // TODO ставить форме submited нельзя - форма общая получаем валидацию главной формы
          form.email.$setTouched();
          form.password.$setTouched();

          this.submiting = true;

          CianMediaAuthentication.LogOn({
            // eslint-disable-line
            // eslint-disable-line
            login: this.email,
            password: this.password,
            onSuccess: () => {
              analyticsService.successAuthorized();

              /**
               * TODO getUser return fake user
               */
              $q.all([
                apiService.getUser(),
                apiService.getUserGeo(),
                apiService.canPublishAsHomeowner({
                  params: { realtyOfferId: addFormService.ad && addFormService.ad.id },
                }),
                commercialOwnerService.canPublishAsCommercialOwner(),
              ])
                .then(([userData, geoData, canPublishAsHomeowner, canPublishAsCommercialOwner]) => {
                  this.submiting = false;
                  homeownerService.userCanPublishThisOfferAsHomeowner = canPublishAsHomeowner;
                  addFormService.ad.isByHomeowner = canPublishAsHomeowner && addFormService.ad.isByHomeowner;
                  commercialOwnerService.changeUserCanPublishAsCommercialOwner(canPublishAsCommercialOwner);

                  const user = userData.data.data;
                  userService.setUser(user, true);
                  analyticsService.authUser(user.cianUserId, user.email);

                  const userGeo = geoData.data.data;
                  if (userGeo) {
                    geoService.setUserGeo(userGeo);
                  }
                })
                .catch(err => {
                  this.submiting = false;
                  $log.error(err);
                });
            },
            onError: response => {
              this.submiting = false;
              this.socialSubmiting = false;

              if (response.errors[0] && response.errors[0].code !== 'passwordWarning') {
                form.remoteValidator.setValidators(response.errors[0]);
              } else {
                this.isPasswordObsolete = true;
                this.passwordObsoleteError = response.errors[0].message;
              }

              $scope.$apply();
            },
            onAjaxError: () => {
              this.submiting = false;
            },
          });
        };
      };
    },
    controllerAs: 'loginCtrl',
    replace: true,
  };
};
